import React from 'react';
import Accordion from '../../components/Accordianitem/Accordion';
import MedicalOrderForm from './PlanContents/MedicalOrder';
import LabOrderForm from './PlanContents/LabOrder';
import ImagingOrderForm from './PlanContents/ImagingOrder';
import ProcedureForm from './PlanContents/ProcedureForm';
import NextAppointmentForm from './PlanContents/NextAppointment';
import { Sparkles } from 'lucide-react';

const staticPlanData = (id: string) => [
  { title: <span className="font-jost text-lg">Medical Order</span>, content: <MedicalOrderForm patientId={id} /> },
  { title: <span className="font-jost text-lg">Lab Order</span>, content: <LabOrderForm patientId={id} /> },
  { title: <span className="font-jost text-lg">Imaging Order</span>, content: <ImagingOrderForm patientId={id}  /> },
  { title: <span className="font-jost text-lg">Procedure (CPT Code)</span>, content: <ProcedureForm patientId={id} /> },
];

const PlanContent: React.FC<{ id: string }> = ({ id }) => {
  console.log('Patient ID:', id);

  const accordionItems = staticPlanData(id);

  return (
    <div className="p-4 space-y-6">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default PlanContent;
